import React from "react";
import { ReactNativeSec } from "./react-native";

export const ReactNative = () => {
  return (
    <React.Fragment>
      <div className="react-native-main">
        <ReactNativeSec />
      </div>
    </React.Fragment>
  );
};
